import { Loader } from "@monolith-forensics/monolith-ui";

import {
  DetailsDisplay,
  DetailsDisplayOrientation,
} from "@/Features/_components";
import { useLabAssetContext } from "../Contexts";
import {
  LAB_ASSET_FIELDS_BY_TYPE,
  LabAssetColumnDefinitions,
} from "../Tables/LabAssetColumnDefinitions";

export const LabAssetDetailsDisplay: React.FC<{
  orientation?: DetailsDisplayOrientation;
  style?: React.CSSProperties;
  dataFieldIgnoreList?: string[];
  hideEmptyFields?: boolean;
}> = ({
  orientation = "horizontal",
  style,
  dataFieldIgnoreList = [],
  hideEmptyFields = false,
}) => {
  const labAssetContext = useLabAssetContext();
  if (!labAssetContext) {
    throw new Error("Lab asset context not found");
  }
  const { data, isPending } = labAssetContext;

  if (isPending) {
    return <Loader />;
  }

  // Only the columns tagged for this asset's type: software keeps its display
  // name in `license_name` (so `name` would repeat it) and has no equipment
  // fields, and vice versa. Same rule as the flyout; an unexpected asset_type
  // falls back to every column rather than none.
  const relevantFields: Set<string> | undefined = data
    ? LAB_ASSET_FIELDS_BY_TYPE[data.asset_type]
    : undefined;
  // asset_number keeps the table's link cell even though it points back at
  // this page: it stays highlighted like everywhere else and supports
  // open-in-new-tab.
  // The page header already shows the due/overdue badge (ENG-1680), so
  // next_validation_due drops the table's badge cell and shows the API's
  // YYYY-MM-DD value as is.
  const columnDefinitions = LabAssetColumnDefinitions.filter(
    (col) => !relevantFields || relevantFields.has(col.dataField)
  ).map((col) =>
    col.dataField === "next_validation_due"
      ? { ...col, render: undefined }
      : col
  );

  return (
    <DetailsDisplay
      columnDefinitions={columnDefinitions}
      data={data || {}}
      orientation={orientation}
      style={style}
      dataFieldIgnoreList={dataFieldIgnoreList}
      hideEmptyFields={hideEmptyFields}
    />
  );
};
